// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
import { createNodeHttpClient } from "./nodeHttpClient";
/**
 * Create the correct HttpClient for the current environment.
 */
export function createDefaultHttpClient() {
    return createNodeHttpClient();
}
//# sourceMappingURL=defaultHttpClient.js.map